<mat-icon>{{ icon }}</mat-icon>
<p>
  {{ title | translate }}
</p>
<span>{{ description | translate }}</span>
